const waveformBars = Array.from({ length: 8 }, (_, index) => ({
  accent: index < 4,
  delay: index * 0.1,
}));

/**
 * The editorial left column for the sign-in screen.
 *
 * The waveform and the note card are illustration, not live data — the same
 * status the mock chart on the landing page has. Nothing here reads the signed-
 * out visitor's account, because at this point there isn't one.
 */
export function LoginEditorial() {
  return (
    <>
      <h1 className="mb-[14px] font-display text-[clamp(38px,5.4vw,68px)] leading-[1.05] tracking-[-0.02em]">
        Welcome back.
        <br />
        Your notes are waiting.
      </h1>

      <p className="m-0 mb-[30px] text-[16.5px] leading-[1.6] text-[rgb(var(--fgc)/0.62)]">
        Pick up any session where you left it — transcripts, drafts and follow-ups stay in sync across your phone and
        desktop.
      </p>

      <div className="surface-flat flex max-w-[400px] items-center gap-[14px] rounded-[16px] p-[18px]">
        <div aria-hidden="true" className="flex h-[30px] w-[66px] flex-none items-end gap-[2px]">
          {waveformBars.map((bar, index) => (
            <span
              key={index}
              style={{ animationDelay: `${bar.delay}s` }}
              className={`h-full flex-1 origin-bottom animate-[mn-wave_1.2s_ease-in-out_infinite] rounded-[2px] ${
                bar.accent ? 'bg-primary' : 'bg-[rgb(var(--fgc)/0.4)]'
              }`}
            />
          ))}
        </div>
        <div className="text-[13.5px] leading-[1.5] text-[rgb(var(--fgc)/0.6)]">
          Record the consult. The draft is <b className="font-semibold text-foreground">ready when you are</b>.
        </div>
      </div>
    </>
  );
}
